import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { Breadcrumbs, useMediaQuery } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

// STYLES
import { SSubscriptionBreadcrumbs } from './styles';

function SubscriptionBreadcrumbs({ activeStep, breadcrumbs, className }) {
  const [t] = useTranslation();
  const matchesUpSm = useMediaQuery(theme => theme.breakpoints.up('sm'));

  if (!breadcrumbs?.length) {
    return null;
  }

  const filteredBreadcrumbs = breadcrumbs.filter(({ title }) => !!title);
  const activeBreadcrumbStep =
    filteredBreadcrumbs.length - 1 < activeStep ? activeStep - 1 : activeStep;

  const stepText = t('subscription.steps_short', {
    active: activeBreadcrumbStep + 1,
    length: filteredBreadcrumbs.length,
  });

  return (
    <SSubscriptionBreadcrumbs className={className}>
      {matchesUpSm ? (
        <Breadcrumbs separator={<i className="icon-chevron-right" />}>
          {filteredBreadcrumbs.map(({ title, onClick }, idx) => {
            const disabled = activeBreadcrumbStep !== idx;

            return (
              <a
                key={idx}
                role="button"
                onKeyDown={() => {}}
                onFocus={() => {}}
                onClick={() => onClick && onClick()}
                tabIndex={-1}
                className={clsx(
                  'p5',
                  disabled && 'disabled',
                  onClick && idx !== activeStep ? 'cursor--pointer' : 'cursor--default',
                )}
              >
                {title}
              </a>
            );
          })}
        </Breadcrumbs>
      ) : (
        <p className="p5">{stepText}</p>
      )}
    </SSubscriptionBreadcrumbs>
  );
}

SubscriptionBreadcrumbs.defaultProps = {
  activeStep: 0,
  breadcrumbs: [],
};

SubscriptionBreadcrumbs.propTypes = {
  className: PropTypes.string,
  activeStep: PropTypes.number,
  breadcrumbs: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
    }),
  ),
};

export default SubscriptionBreadcrumbs;
